import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { requestOTP, ValidateOTP, GetPriceRule, CartCheckout, RegisterPayment, GetCartItems, ValidateEmail, GetCartItemRequestObj, GetCheckoutObj } from './module';
import moment from 'moment';

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const initialState = {
    mySession: null,
    OTPKey: null,
    countdownNo: 60,
    shopCode: sessionStorage.getItem('shopCode') ? sessionStorage.getItem('shopCode') : null,
    cartItems: sessionStorage.getItem('cartItems') ? JSON.parse(sessionStorage.getItem('cartItems')) : [],
    archivalFormData: sessionStorage.getItem('afs') ? JSON.parse(sessionStorage.getItem('afs')) : null,
    shoppingCart: sessionStorage.getItem('shoppingCart') ? JSON.parse(sessionStorage.getItem('shoppingCart')) : null,
    isRequestedOtp: false,
    priceRules: null,
    disableBtn: false,
    status: "idle",
    ActionStatus: "",
    errorMessage: "",
    paymentloading: false
};

export const ValidateEmailAsync = createAsyncThunk(
    'archivalSummary/requestOTP',
    async (data, ThunkAPI) => {
        const response = await ValidateEmail(data);
        return response;
    }
);

export const GetPriceRuleAsync = createAsyncThunk(
    'archivalSummary/GetPriceRule',
    async (data, ThunkAPI) => {
        const response = await GetPriceRule();
        return response;
    }
);

export const resendOTPAsync = createAsyncThunk(
    'archivalSummary/resendOTP',
    async (data, ThunkAPI) => {
        const response = await requestOTP(data);
        return response;
    }
);

export const GetCartItemsAsync = createAsyncThunk(
    'archivalSummary/GetCartItems',
    async (data, ThunkAPI) => {
        const response = await GetCartItems(data);
        return response;
    }
);

export const CartCheckoutAsync = createAsyncThunk(
    'archivalSummary/CartCheckout',
    async (json, ThunkAPI) => {
        const response = await CartCheckout(json);
        const resultPromise = Promise.resolve(response);
        resultPromise.then((r, index) => {
            var data = r;
            var getListInv = [];
            if (data && data.Status === 'OK') {
                var shoppingCart = JSON.parse(sessionStorage.getItem('shoppingCart'));
                sessionStorage.removeItem('afs');
                sessionStorage.removeItem('shopCode');
                sessionStorage.removeItem('cartItems');
                window.wogaaCustom.completeTransactionalService('ArchivesOnline-2860');
                if (parseFloat(shoppingCart.availableAfterPayment.finalAmount)) {
                    data.Orders.forEach((invoiceItem) => {
                        invoiceItem.Invoices.forEach((item) => {
                            getListInv.push(item.InvoiceId);
                        })
                    });

                    var payment_data = {
                        OrderCode: data.Orders[0].OrderCode,
                        InvoiceIds: getListInv
                    }

                    ThunkAPI.dispatch(RegisterPaymentAsync(payment_data));
                } else {
                    sessionStorage.removeItem('shoppingCart');
                    var orderCode = data.Orders ? data.Orders[0].OrderCode : '';
                    setTimeout(() => {
                        window.location.href = "./order/success?order_code=" + orderCode;
                    }, 500);
                }

            } else {
                alert('Failed to get payment data!');
            }

        })
        return response;
    }
);

export const RegisterPaymentAsync = createAsyncThunk(
    'archivalSummary/RegisterPayment',
    async (data, ThunkAPI) => {
        const response = await RegisterPayment(data);
        return response;
    }
);

export const ValidateOTPAsync = createAsyncThunk(
    'archivalSummary/validateOTP',
    async (data, ThunkAPI) => {
        const response = await ValidateOTP(data);
        const resultPromise = Promise.resolve(response);
        resultPromise.then((r, index) => {
            if (r && r.Status === 'OK') {
                ThunkAPI.dispatch(checkOutCurCart());
            } else {
                alert('Failed to validate OTP');
            }
        })
        return response;
    }
);

export const archivalSummarySlice = createSlice({
    name: 'archivalSummary',
    initialState,
    reducers: {
        clearAction: (state, action) => {
            //state.isRequestedOtp = null;
            state.paymentloading = false;
        },
        ChangeCountdownNumber: (state, action) => {
            state.countdownNo = action.payload;
        },
        triggerDisableBtn: (state, action) => {
            state.disableBtn = action.payload;
        },
        CartFilterPhy: (state, action) => {
            if (state.cartItems && state.cartItems.length > 0) {
                state.cartItems.forEach((item) => {
                    if (item.Format === "PHY") {
                        state.countPhysical += 1;
                        state.countPhysicalItemPice += item.Price;
                    }
                });
            }
        },
        combineCartItems: (state, action) => {
            var matching_checkoutArray = [];
            var getCart = [];
            state.cartItems.forEach(function (item) {
                matching_checkoutArray.push(item.CartItemId);
                var citems = {
                    CartItemId: item.CartItemId,
                    FullOrPartial: item.FullOrPartial,
                    StartTime: moment(item.Start_Time, 'HH:mm:ss').diff(moment().startOf('day'), 'seconds'),
                    EndTime: moment(item.End_Time, 'HH:mm:ss').diff(moment().startOf('day'), 'seconds'),
                    FirstWords: item.First_Few_Words,
                    LastWords: item.Last_Few_Words,
                    Format: item.Format,
                    Pages: item.PagesNeeded ?? null
                }
                getCart.push(GetCartItemRequestObj(citems));
            });

            var CartItems = {
                CartItems: getCart
            }

            var extra_data = {
                // Cookies_ID: getCookie('ShoppingCartCookie'),
                TotalAmount: (state.shoppingCart.subjectToApproval.finalAmount ? parseFloat(state.shoppingCart.subjectToApproval.finalAmount) : 0) + (state.shoppingCart.availableAfterPayment.finalAmount ? parseFloat(state.shoppingCart.availableAfterPayment.finalAmount) : 0),
                ShopCode: state.shopCode
            }
            state.merge_cookieID = {
                ...state.archivalFormData,
                ...extra_data
            }

            state.extend_CartItems = GetCheckoutObj({
                ...state.merge_cookieID,
                ...CartItems
            });

        }
    },
    extraReducers: (builder) => {
        builder.addCase(ValidateEmailAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(ValidateEmailAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(ValidateEmailAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.isRequestedOtp = true;
                state.OTPKey = action.payload.OTPKey
            }
        });
        builder.addCase(resendOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(resendOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(resendOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.OTPKey = action.payload.OTPKey
            }
        });
        builder.addCase(ValidateOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(ValidateOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(ValidateOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
        });
        builder.addCase(GetPriceRuleAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetPriceRuleAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetPriceRuleAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.priceRules = action.payload ? action.payload.PriceRules.map(item => {
                    item.SetPrice = parseFloat(parseFloat(item.SetPrice).toFixed(2))
                    return item;
                }) : null;
            }
        });
        builder.addCase(CartCheckoutAsync.pending, (state) => {
            state.status = 'loading';
            state.paymentloading = true;
        });
        builder.addCase(CartCheckoutAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(CartCheckoutAsync.fulfilled, (state, action) => {
            state.status = 'idle';

            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
                state.paymentloading = false;
            }
        });
        builder.addCase(RegisterPaymentAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(RegisterPaymentAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(RegisterPaymentAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            } else {
                sessionStorage.removeItem('shoppingCart');
                state.paymentloading = true;
                var payment = action.payload;
                var form = document.createElement("form");
                var paymentElement = document.createElement("input");

                form.method = "POST";
                form.action = payment.Url;

                paymentElement.value = payment.PaymentXml;
                paymentElement.type = "hidden";
                paymentElement.name = "PAYMENT";

                form.appendChild(paymentElement);

                document.body.appendChild(form);

                form.submit();
            }

        });

    }
});

export const { clearAction, triggerDisableBtn, ChangeCountdownNumber, CartFilterPhy, combineCartItems } = archivalSummarySlice.actions;
export const pagesState = (state) => state.archivalSummary;
export const shoppingCart = (state) => state.archivalSummary.shoppingCart;
export const formData = (state) => state.archivalSummary.archivalFormData;
export const mySession = (state) => state.Session.mySession;
export const myLibs = (state) => state.Session.myLibs;
export const paymentloading = (state) => state.archivalSummary.paymentloading;

export const checkOutCurCart = (data) => (dispatch, getState) => {
    dispatch(CartCheckoutAsync(getState().archivalSummary.extend_CartItems));
};


export default archivalSummarySlice.reducer;
